export const NAME = 'quals';
export const LEVEL_ONE = 'QualsComponentReducer';
